function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M31.89 47C21.31 47 11 41.65 2.9 31.91 11.66 22.15 21.78 17 32.18 17s20.27 5.15 28.92 14.92C53 41.65 42.64 47 31.89 47z",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 4
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32 25.4a7.06 7.06 0 014.9 2.17 6.44 6.44 0 012 4.59c-.08 3.31-3.31 6.37-6.85 6.41a6.91 6.91 0 01-4.84-2 6.37 6.37 0 01-1.94-4.65 6.89 6.89 0 016.66-6.48",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 4
});

function SvgShow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+c2hvdzwvdGl0bGU+PHBhdGggZD0iTTMxLjg5LDQ3QzIxLjMxLDQ3LDExLDQxLjY1LDIuOSwzMS45MSwxMS42NiwyMi4xNSwyMS43OCwxNywzMi4xOCwxN1M1Mi40NSwyMi4xNSw2MS4xLDMxLjkyQzUzLDQxLjY1LDQyLjY0LDQ3LDMxLjg5LDQ3WiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjxwYXRoIGQ9Ik0zMiwyNS40YTcuMDYsNy4wNiwwLDAsMSw0LjksMi4xNyw2LjQ0LDYuNDQsMCwwLDEsMiw0LjU5Yy0uMDgsMy4zMS0zLjMxLDYuMzctNi44NSw2LjQxYTYuOTEsNi45MSwwLDAsMS00Ljg0LTIsNi4zNyw2LjM3LDAsMCwxLTEuOTQtNC42NSw2Ljg5LDYuODksMCwwLDEsNi42Ni02LjQ4IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iNCIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
export { SvgShow as ReactComponent };